export enum SearchFilterTypeEnum {
  Checkbox = 1,
  Range = 2,
  CatStatus,
  Keyword
}
